module.exports = __webpack_public_path__ + "img/3.ad42133a.jpg";